module.exports = __webpack_public_path__ + "img/huazhang.6dac4bac.png";